<template>
    <v-app>
        <v-main>
            <v-row justify="center">
                <v-col cols="12" md="10">
                    <v-card class="ma-1">
                        <v-card-title v-text="title" />
                        <v-card-subtitle v-text="date" />
                        <v-card-text v-html="markdownRendered" />
                    </v-card>
                </v-col>
            </v-row>
        </v-main>
    </v-app>
</template>

<script>
import { marked } from 'marked';

export default ({
    props: {
        text: String,
        title: String,
        date: String,
    },
    computed: {
        markdownRendered: function() {
            return marked(this.text);
        }
    }
})
</script>
